import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberMiles',
    pure: false
})

export class NumberMilesPipe implements PipeTransform {

    public transform(value: any) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");;
    }
}